import { useState } from "react";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

export default function PasswordGenerator() {
  const [length, setLength] = useState(12);
  const [useUpper, setUseUpper] = useState(true);
  const [useLower, setUseLower] = useState(true);
  const [useNumbers, setUseNumbers] = useState(true);
  const [useSymbols, setUseSymbols] = useState(false);
  const [password, setPassword] = useState("");

  const generatePassword = () => {
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const symbols = "!@#$%^&*()_+-=[]{}|;:,.<>?";

    let chars = "";
    if (useUpper) chars += upper;
    if (useLower) chars += lower;
    if (useNumbers) chars += numbers;
    if (useSymbols) chars += symbols;

    if (!chars) {
      setPassword("Select at least one option!");
      return;
    }

    let generated = "";
    for (let i = 0; i < length; i++) {
      generated += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setPassword(generated);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(password);
    alert("Password copied to clipboard!");
  };

  return (
    <>
      <Helmet>
        <title>Password Generator - Secure Random Passwords for Safety</title>
        <meta
          name="description"
          content="Generate strong, secure, and random passwords with custom length and character options. Free online password generator tool for enhanced security."
        />
        <meta
          name="keywords"
          content="password generator, strong passwords, secure passwords, random password generator, free password tool, generate passwords, online password generator"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://freelity.com/password-generator" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>Password Generator</h2>

          <div className="form-group mb-3">
            <label>Password Length: {length}</label>
            <input
              type="range"
              min="4"
              max="32"
              value={length}
              className="form-range"
              onChange={(e) => setLength(e.target.value)}
            />
          </div>

          <div className="form-check">
            <input className="form-check-input" type="checkbox" checked={useUpper} onChange={() => setUseUpper(!useUpper)} />
            <label className="form-check-label">Include Uppercase</label>
          </div>

          <div className="form-check">
            <input className="form-check-input" type="checkbox" checked={useLower} onChange={() => setUseLower(!useLower)} />
            <label className="form-check-label">Include Lowercase</label>
          </div>

          <div className="form-check">
            <input className="form-check-input" type="checkbox" checked={useNumbers} onChange={() => setUseNumbers(!useNumbers)} />
            <label className="form-check-label">Include Numbers</label>
          </div>

          <div className="form-check mb-3">
            <input className="form-check-input" type="checkbox" checked={useSymbols} onChange={() => setUseSymbols(!useSymbols)} />
            <label className="form-check-label">Include Symbols</label>
          </div>

          <button className="btn btn-primary mb-3" onClick={generatePassword}>
            Generate Password
          </button>

          <div className="form-control mb-3" readOnly>{password}</div>

          <button className="btn btn-success" onClick={copyToClipboard}>
            Copy to Clipboard
          </button>
        </div>
      </section>
    </>
  );
}
